import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bigClose",
  "use": "bigClose-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bigClose\">\n<rect width=\"24.1221\" height=\"4.02036\" transform=\"matrix(0.710669 -0.703526 0.710669 0.703526 0 17)\" fill=\"#26A69A\" />\n<rect width=\"24.1221\" height=\"4.02036\" transform=\"matrix(0.710669 0.703526 -0.710669 0.703526 2.85718 0)\" fill=\"#26A69A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/bigClose.svg
// module id = cq4q
// module chunks = 13